import React, { useState, useEffect, Fragment } from "react";
import "./style.scss";
import useFetch from "../../cache/useFetch";
import { useNavigate } from "react-router-dom";
import { GET, HEADER, HEADER_URL, LANGUAGE_PREFIX } from "../../helper/constants";
import { useLanguage } from "../../cache/context/LanguageProvider";
import HEADER_DATA from "../../constants/data-header";
import { useSearchParams } from 'react-router-dom';
import BusinessContactModal from "../BussinessContactModal";

 const Header = () => {
  const navigate = useNavigate();
  const [isActive, setActive] = useState(false);
  const [showTopMenu, setshowTopMenu] = useState(false);
  const [scrolltopdata, setscrolltopdata] = useState('');
  const [mainHeader, setMainHeader] = useState([]);
  const [toggle, setToggle] = useState(false);
  const top_head = document.querySelector(".top-menu")
  const [childMenu, setchildMenu] = useState([]);
  const [selectedElement, setSelectedElement] = useState('');
  const [languageOptions, setLanguageOptions] = useState(['EN', 'SW'])
  const [searchParams] = useSearchParams();
  const pageName = searchParams.get('name');
   const [showContactModal, setShowContactModal] = useState(false);
  const { languagePrefix, selectedLanguage: userSelectedLang, setSelectedLanguage } = useLanguage();
  const { data: data, refetch } = useFetch({
    url: HEADER_URL.replace(LANGUAGE_PREFIX, languagePrefix),
    method: GET,
    key: HEADER,
    initialEnabled: false,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 350) {
        setscrolltopdata("scrolled");
      } else {
        setscrolltopdata("");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  

  useEffect(() => {
    const interval = setInterval(() => {
      const contactUs = document.getElementById('contact-agent');
      if (contactUs) {
        contactUs.addEventListener('click', openBusinessContactModal);
        clearInterval(interval); // Stop polling once attached
      }
    }, 300); // Check every 300ms

    return () => {
      clearInterval(interval);
      const contactUs = document.getElementById('contact-agent');
      if (contactUs) {
        contactUs.removeEventListener('click', openBusinessContactModal);
      }
    };
  }, []);


  // const handleResize = () => {
  //     if (window.innerWidth < 767) {
  //         setshowTopMenu(true)
  //     }
  //     else {
  //       setshowTopMenu(false)
  //     }
  // }

  // useEffect(() => {
  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []); 



  useEffect(() => {
    setToggle(false);
  }, [window.location.href])

  useEffect(() => {
    const cachedData = sessionStorage.getItem(`${HEADER}_${userSelectedLang}`);
    if (!cachedData) {
      refetch(true);
    } else {
      refetch(false)
    }
  }, [userSelectedLang]);

  useEffect(() => {
    if (!data) {
      setMainHeader(HEADER_DATA)
    }
    else {
      setMainHeader(data)
    }
  }, [data])

  useEffect(() => {
    setToggle(false)
    setActive(false);
  }, [window.location.href])

  

  const base_link = "";

  const handleNavigation = (link = "") => {
    if (link == 'javascript:void(0);' || !link) { return }
    navigate(link);
  }


    const toggleClass = () => {
      setActive(!isActive);
      if (isActive) {
        top_head.classList.remove("active")
      }
      else {
        top_head.classList.add("active")
      }
    }

    const handalLinkToggle = (item) => {
      top_head.classList.remove("active")
      setSelectedElement(item?.name)
      if (item.link == '' || !item.link) {
        setToggle(true)
        setchildMenu(item.child)
      }
      else {
        setToggle(false)
        if (item?.target) {
          window.open(item.link, "_blank");
          return
        }
        navigate(item.link)
      }
    }

    const handalLinkTopMenu = (item) => {
      navigate(item.link)
      if (item.link == "https://developers.airtel.africa") {
        window.open(item.link, "_blank");
        navigate("/")
      }
      top_head.classList.remove("active")
    }

   const openBusinessContactModal = () => {
     setShowContactModal(true)
   }


    const MenuItem = ({ item }) => {

      return (
        <li>
          <a onClick={() => item.link && handleNavigation(item.link)} className={item?.child?.length > 0 ? 'mega-menu-link submenu_arrow_link' : 'mega-menu-link'}>{item.name}</a>
          {item.child.length ? (
            <> <input type="checkbox" />
              <span className={item?.child?.length > 0 ? 'submenu_arrow' : ''}></span>
              <ul className="sub-menu">
                {item.child.map((subchild, index) => (
                  <MenuItem key={index} item={subchild} />
                ))}
              </ul> </>
          ) : null}
        </li>
      );
    }

    const toggleModalVisibilty=()=>{
      setShowContactModal(!showContactModal);
    }

    return (
      <>
      <header className="header">
        <div className="maine-menu" >
        <div className="container top-menu">
        <div className="top-container">
          {!(pageName && mainHeader?.[pageName]?.length) && <ul>
            {!!mainHeader?.top_header?.length && mainHeader?.top_header.map((menu, idx) => (
              <li key={idx}>
                <a onClick={() => handalLinkTopMenu(menu)}> {menu.name}</a>
              </li>
            ))}
          </ul>}

          {process.env.REACT_APP_OPCO == "TZ" &&<>
            <select className="languageToggle"
              name="select"
              value={userSelectedLang}
              onChange={(e) => {
                setSelectedLanguage(e.target.value);
                sessionStorage.setItem("selectedLanguage", e.target.value)
              }}
            >
              {languageOptions.map((lang, index) => (
                <option key={index} value={lang}>
                  {lang}
                </option>
              ))}
            </select>
          </>}
        </div> </div>
          <div className="container">
            <div className="top-wrap">
              <a className="logo" crossOrigin="anonymous" target="_self" href="/">
                <img alt="airtel_logo" src="/assets/images/logo.svg" />
              </a>
              <div onClick={toggleClass} className={`mobile-menu ${isActive ? 'active' : ''}`} id="nav-wrap">
                <img className="menu" alt="Menu" src="assets/images/mobile-Menu.svg" />
                <img className="x-menu" alt="Menu" src="assets/images/close_icon.svg" />
              </div>
            </div>

            <div className={`toggle-container ${isActive ? 'active' : ''}`} id="nav-wrap">
            <ul className="main-nav">
              
               <ul className="xs-menu">
                {( (!(pageName && mainHeader?.[pageName]?.length) ) && !!mainHeader?.top_header?.length ) && mainHeader?.top_header.map((menu, idx) => (
                    <li key={idx}>
                      <a onClick={() => handalLinkTopMenu(menu)}> {menu.name}</a>
                    </li>
                ))}
               </ul>
               
                
                {(pageName && mainHeader?.[pageName]?.length )?
                  <>
                  {!!mainHeader?.[pageName]?.length && mainHeader?.[pageName].map((menu, idx) => (<>
                    <li key={idx}>
                      <a
                        // "mega-menu-link "
                        className={menu?.child?.length > 0 ? 'mega-menu-link submenu_arrow_link' : 'mega-menu-link'}
                        data-i18n={menu.id}
                        data-mega-menu={menu.id}
                        module-id="common"
                        onClick={() => menu.link && handleNavigation(menu.link)}
                        target="_self"
                      >
                        {menu.name}
                        {!!menu.child.length && <img className="visible-lg" src="assets/icons/down_arrow_icon.svg" width={"15"} />}
                      </a>
                      {menu?.child?.length ? (<>
                        <input type="checkbox" />
                        <span className={menu?.child?.length > 0 ? 'submenu_arrow' : ''}></span>
  
                        <ul className="sub-menu">
                          {menu.child.map((children, index) => (
                            <MenuItem key={index} item={children} />
                          ))}
                        </ul>
                      </>
                      ) : null}
                    </li>
                   
                    </>
                  ))}
                   <button className="button talkToExpertCta" onClick={openBusinessContactModal}>{mainHeader?.actionTitles?.[pageName]}</button>
                  </>

                 : <>{!!mainHeader?.main_header?.length && mainHeader?.main_header.map((menu, idx) => (
                  <li key={idx}>
                    <a
                      // "mega-menu-link "
                      className={menu?.child?.length > 0 ? 'mega-menu-link submenu_arrow_link' : 'mega-menu-link'}
                      data-i18n={menu.id}
                      data-mega-menu={menu.id}
                      module-id="common"
                      onClick={() => menu.link && handleNavigation(menu.link)}
                      target="_self"
                    >
                      {menu.name}
                      {!!menu.child.length && <img className="visible-lg" src="assets/icons/down_arrow_icon.svg" width={"15"} />}
                    </a>
                    {menu.child.length ? (<>
                      <input type="checkbox" />
                      <span className={menu?.child?.length > 0 ? 'submenu_arrow' : ''}></span>

                      <ul className="sub-menu">
                        {menu.child.map((children, index) => (
                          <MenuItem key={index} item={children} />
                        ))}
                      </ul>
                    </>
                    ) : null}
                  </li>
                ))}</>
                }

              </ul>
             
            </div>
          </div>
        </div>
        {/* <div className="m-mobile-menu" id="voice-data"></div> */}
      </header>
      {showContactModal &&  <BusinessContactModal toggleModalVisibilty={toggleModalVisibilty}/>}
      </>
    );
  };


  export default Header;

